export const PRODUCT_STATUSES = strings => {
  return {
    available: strings.available,
    unavailable: strings.unavailable,
    discontinued: strings.discontinued
  }
}
